document.addEventListener('DOMContentLoaded', () => {
    let phone = document.querySelector('[name="phone"]')
    let code = document.querySelector('[name="code"]')

    if (phone && ! phone.classList.contains('js-no-mask')) {
        IMask(
            document.querySelector('[name="phone"]'),
            {
                mask: '+38 (000) 000-00-00',
            }
        )
    }

    if (code && ! code.classList.contains('js-no-mask')) {
        IMask(
            code,
            {
                mask: '0000',
            }
        )
    }

    if (document.querySelector('.js-resend-timer') && document.querySelector('.js-resend-button')) {
        let time = parseFloat(document.querySelector('.js-resend-timer').textContent)
        let timer = document.querySelector('.js-resend-timer')
        let btn = document.querySelector('.js-resend-button')

        let interval = setInterval(() => {
            if (time--) {
                timer.textContent = `${time}`;
            } else {
                btn.classList.remove('d-none')
                timer.classList.add('d-none')
                timer.parentNode.querySelectorAll('small').forEach(el => el.classList.add('d-none'));
                clearInterval(interval)
            }
        }, 1000);
    }
})